import MainLayout from "../components/layouts/MainLayout";
import Hero from "../components/Hero";
import Container from "../components/Container";
import Accordion from "../components/Accordion";
import SectionVideo from "../components/sections/SectionVideo";
import SectionQuestions from "../components/sections/SectionQuestions";
import imageHeroDesktop from "../public/img/hero/job_offers_desktop.jpg";
import imageHeroMobile from "../public/img/hero/job_offers_mobile.jpg";
import imageHandling from "../public/img/jobs/handling.jpg";
import imageCargo from "../public/img/jobs/cargo.jpg";
import imageCleaning from "../public/img/jobs/cleaning.jpg";
import imageCatering from "../public/img/jobs/catering.jpg";
import SectionFloating from "../components/sections/SectionFloating";
import {generateTitle} from "../helpers/meta";
import Head from "next/head";
import CompanyLogos from "../components/CompanyLogos";
import {useRouter} from "next/router";
import localized from "../locale/locales";
import Title from "../components/Title";

const jobOfferImages = {
    handling: imageHandling,
    cargo: imageCargo,
    cleaning: imageCleaning,
    catering: imageCatering,
};

export default function JobOffers() {
    const {locale} = useRouter();
    const {jobOffers: lang} = localized[locale];

    const jobOffers = lang.inAirport.list.map(({title, body, image}) => {
        return {
            title,
            body,
            image: jobOfferImages[image]
        }
    });

    return (
        <MainLayout>
            <Head>
                <title key="title">{generateTitle(lang.og.title)}</title>
                <meta key="og:title" property="og:title" content={generateTitle(lang.og.title)}/>
                <meta key="description" name="description" content={lang.og.description}/>
                <meta key="og:description" property="og:description" content={lang.og.description}/>
            </Head>

            <SectionFloating scheme="job-offers"/>

            <Hero direction="image-left"
                  imageDesktop={imageHeroDesktop}
                  imageMobile={imageHeroMobile}
                  className="relative items-end gap-6 lg:gap-10 lg:pt-5"
            >
                <div className="flex flex-col gap-7 md:gap-5 md:pb-10 accent-lilac-800">
                    <div className="flex flex-col gap-5">
                        <header>
                            <Title Elem="h1" className="relative inline-flex flex-col">
                                {lang.header.title.localize({emoji: '<span class="absolute top-0 md:-top-1 -right-6 md:-right-8 text-2xl md:text-4xl">🛩</span>'})}
                            </Title>
                        </header>
                        <p className="leading-[1.8] max-w-[47ch]">
                            {lang.header.body}
                        </p>
                    </div>
                </div>
            </Hero>

            <Container className="flex flex-col gap-8 accent-lilac-800 pt-14 md:pt-36">
                <header>
                    <Title size="small">
                        {lang.inAirport.title.localize()}
                    </Title>
                </header>

                <div className="w-full max-w-[970px] mx-auto">
                    <Accordion items={jobOffers}/>
                </div>
            </Container>

            <SectionVideo>
                <header className="accent-purple-800">
                    <Title className="md:max-w-[11ch]">
                        {lang.video.title.localize()}
                    </Title>
                </header>
                <p className="max-w-[38ch] leading-[1.8]">
                    {lang.video.body}
                </p>
            </SectionVideo>

            <Container className="relative text-center flex flex-col items-center gap-12 pb-20 md:pb-0">
                <header>
                    <h2 className="text-black/40 text-base md:text-lg">{lang.logos.title}</h2>
                </header>
                <CompanyLogos/>
            </Container>

            <SectionQuestions className="accent-lilac-800">
                <Title>{lang.questions.title.localize({emoji: '💬'})}</Title>
            </SectionQuestions>
        </MainLayout>
    )
}
